var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 408,
    viewBox: "0 0 676 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 126.923 154.334)",
    fill: "#EDE7F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 128.644 155.326)",
    fill: "#B39DDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 502.58 181.299)",
    fill: "#EDE7F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 504.3 182.291)",
    fill: "#B39DDB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26.998,
    height: 26.8293,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 315.505 289.492)",
    fill: "#E3F2FD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.2748,
    height: 24.1231,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 317.881 290.48)",
    fill: "#90CAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 4.32639 197.529)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 342.15 387.578)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 27.8408 211.105)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 365.664 374.002)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 51.3551 224.68)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 389.179 360.428)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 74.8696 238.256)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 412.693 346.852)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 98.3839 251.83)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 436.208 333.277)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 121.898 265.406)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 459.722 319.703)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 145.413 278.98)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 483.236 306.127)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 168.927 292.555)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 506.751 292.551)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 192.432 306.127)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 530.265 278.977)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 215.946 319.703)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 553.779 265.402)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 239.461 333.277)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 577.294 251.826)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.066 346.904L600.899 151.871",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 600.808 238.252)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 286.49 360.428)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 624.322 224.678)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 310.004 374.002)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 647.837 211.102)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(0.866041 -0.499972 -0.866041 -0.499972 333.518 387.578)",
    stroke: "#8492C4"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 390.089,
    y2: -0.5,
    transform: "matrix(-0.866041 -0.499972 -0.866041 0.499972 671.351 197.527)",
    stroke: "#8492C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.282 229.183C406.318 224.119 402.79 217.933 398.397 215.371C396.1 214.026 394.028 213.967 392.56 214.923L387.161 217.945L398.468 237.375L403.82 234.353L403.808 234.341C405.323 233.55 406.27 231.768 406.282 229.183Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.797 218.536C397.178 221.097 400.706 227.283 400.682 232.347C400.647 237.411 397.071 239.442 392.679 236.88C388.298 234.318 384.77 228.133 384.794 223.069C384.829 218.005 388.416 215.974 392.797 218.536Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.062 226.149C390.074 224.165 391.293 223.268 392.773 224.13C394.253 224.992 395.449 227.305 395.437 229.289C395.425 231.272 394.206 232.169 392.726 231.307C391.234 230.434 390.038 228.12 390.062 226.149Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M400.682 232.346C400.694 230.634 400.291 228.805 399.605 227.034L385.906 219.113C385.22 220.069 384.817 221.403 384.805 223.08C384.805 223.139 384.817 223.209 384.817 223.268L400.682 232.452C400.67 232.417 400.682 232.382 400.682 232.346Z",
    fill: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.595 272.375C346.588 272.54 343.533 272.056 341.165 270.864L266.529 227.99C262.018 225.724 256.951 219.845 256.643 214.285L254.346 161.271L258.502 161.035L260.799 214.049C261.012 217.838 264.99 222.572 268.4 224.284L343.036 267.157C346.493 268.893 352.342 268.55 355.562 266.437L405.335 237.847C406.531 237.068 407.206 236.135 407.158 235.356C407.111 234.577 406.365 233.774 405.11 233.149L325.205 186.899C320.706 184.644 315.663 178.754 315.343 173.182L314.23 143.777L318.386 143.541L319.499 172.946C319.712 176.735 323.678 181.481 327.064 183.18L406.969 229.43C409.633 230.764 411.184 232.783 411.314 235.12C411.444 237.434 410.095 239.688 407.62 241.317L357.847 269.908C355.621 271.36 352.626 272.198 349.595 272.375Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.169 271.183C336.204 266.119 332.676 259.933 328.284 257.371C325.987 256.026 323.915 255.967 322.447 256.923L317.048 259.945L328.355 279.375L333.706 276.353L333.694 276.341C335.21 275.55 336.157 273.768 336.169 271.183Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.695 260.536C327.076 263.097 330.604 269.283 330.581 274.347C330.545 279.411 326.969 281.442 322.577 278.88C318.196 276.318 314.668 270.133 314.692 265.069C314.727 260.005 318.303 257.974 322.695 260.536Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.949 268.149C319.961 266.165 321.18 265.268 322.66 266.13C324.14 266.992 325.336 269.305 325.324 271.289C325.312 273.272 324.093 274.169 322.613 273.307C321.121 272.434 319.937 270.12 319.949 268.149Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.044 239.488C281.092 234.424 277.563 228.227 273.195 225.665C270.898 224.32 268.826 224.249 267.358 225.205L261.959 228.215L273.23 247.669L278.582 244.659L278.57 244.647C280.073 243.856 281.02 242.074 281.044 239.488Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.583 228.818C271.963 231.391 275.48 237.577 275.432 242.641C275.397 247.705 271.809 249.735 267.429 247.162C263.048 244.588 259.532 238.403 259.579 233.339C259.627 228.275 263.202 226.256 267.583 228.818Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.824 236.419C264.836 234.436 266.055 233.539 267.535 234.412C269.015 235.286 270.211 237.588 270.187 239.571C270.176 241.554 268.956 242.451 267.476 241.578C265.996 240.716 264.812 238.402 264.824 236.419Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49 97.0303C243.904 91.8953 246.295 85.273 250.806 82.3219L300.426 54.3571C304.936 51.406 309.874 53.46 311.46 58.5949L314.905 69.7265L311.496 71.7097L307.813 60.46C306.937 57.7332 304.262 56.8006 301.87 58.3824L253.541 85.6272C250.652 87.5395 249.09 91.8127 250.06 95.118L252.973 105.801L248.912 108.162L245.49 97.0303Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.198 150.67L255.542 189.046L352.957 245.118L419.613 206.741L322.198 150.67Z",
    fill: "#27DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M322.198 150.67L255.542 189.046L352.957 245.118L419.613 206.741L322.198 150.67Z",
    fill: "#8492C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.924 108.162L314.893 69.7266L322.198 150.67L255.542 189.046L248.924 108.162Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.993 150.67L419.613 206.741L322.198 150.67L314.893 69.7383L431.993 150.67Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.1543,
    height: 84.0507,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 267.28 160.576)",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.493 189.046L352.957 245.118L255.542 189.046L248.493 107L354.493 189.046Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.493 189.5L431.993 149.5L419.613 206.753L352.957 245.117L354.493 189.5Z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.434 102.125L328.691 107.75L327.311 61.25L339.814 54.0312L338.434 102.125ZM333.562 112.344C335.538 111.203 337.121 110.961 338.312 111.617C339.53 112.258 340.139 113.625 340.139 115.719C340.139 117.781 339.53 119.836 338.312 121.883C337.121 123.914 335.538 125.5 333.562 126.641C331.614 127.766 330.031 128.008 328.813 127.367C327.622 126.711 327.027 125.352 327.027 123.289C327.027 121.227 327.622 119.18 328.813 117.148C330.031 115.07 331.614 113.469 333.562 112.344Z",
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.993 127.57C323.493 123.57 329.493 111.57 336.993 111.07H342.993C341.993 113.904 339.693 120.17 338.493 122.57C337.923 123.71 341.993 127.57 334.493 128.07C334.493 128.07 331.493 128.57 328.993 127.57Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.434 102.125L334.691 107.75L333.311 61.25L345.814 54.0312L344.434 102.125ZM339.562 112.344C341.538 111.203 343.121 110.961 344.312 111.617C345.53 112.258 346.139 113.625 346.139 115.719C346.139 117.781 345.53 119.836 344.312 121.883C343.121 123.914 341.538 125.5 339.562 126.641C337.614 127.766 336.031 128.008 334.813 127.367C333.622 126.711 333.027 125.352 333.027 123.289C333.027 121.227 333.622 119.18 334.813 117.148C336.031 115.07 337.614 113.469 339.562 112.344Z",
    fill: "#B39DDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.993 54.0703H345.993L333.493 61.5703L327.493 61.0703L338.993 54.0703Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.493 107.57L326.993 61.0703L333.493 61.5703L334.993 107.57H328.493Z",
    fill: "url(#paint5_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 181,
    y: 52.998,
    width: 314.993,
    height: 354.99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 285.561,
    y1: 69.7266,
    x2: 285.561,
    y2: 189.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 374.943,
    y1: 69.7383,
    x2: 374.943,
    y2: 206.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 301.708,
    y1: 108.162,
    x2: 301.708,
    y2: 245.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90CAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 326.993,
    y1: 112.57,
    x2: 336.493,
    y2: 127.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673AB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 345.993,
    y1: 53.5703,
    x2: 322.993,
    y2: 63.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE7F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 330.993,
    y1: 106.57,
    x2: 329.493,
    y2: 45.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39DDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDark);
export default __webpack_public_path__ + "static/media/empty-dark.a630f95446bca452f87446636b72917e.svg";
export { ForwardRef as ReactComponent };